import { defineComponent as n, onMounted as l, provide as s, computed as d, createBlock as p, openBlock as b, normalizeClass as u, unref as e, withCtx as m, renderSlot as c } from "vue";
import r from "@leaflink/snitch";
import { M as v } from "./Module.keys-CEsrW2f0.js";
import { _ as w } from "./Box.vue_vue_type_script_setup_true_lang-rFnvwLVY.js";
import { M as t } from "./Module.types-B1FfGGac.js";
const y = /* @__PURE__ */ n({
  name: "ll-module",
  __name: "Module",
  props: {
    variant: { default: "box" },
    disablePadding: { type: Boolean },
    disableGutters: { type: Boolean },
    disableElevation: { type: Boolean },
    radius: {}
  },
  setup(o) {
    const a = o;
    return l(() => {
      a.variant === "card" && r.warn('Card Modules are no longer a thing. You\'re probably looking for `<RadioGroup variant="card">`.'), a.variant === "list" && r.warn("Only used with deprecated ListView component. Use `table` variant with `Table` component instead.");
    }), s(v.key, { variant: d(() => a.variant) }), (i, f) => (b(), p(w, {
      class: u(["stash-module tw-flex tw-flex-col", {
        "tw-bg-transparent tw-shadow": a.variant === e(t).Table,
        "tw-border tw-border-ice-500": a.variant === e(t).Card,
        "tw-mb-6 tw-bg-transparent tw-shadow-none lg:tw-shadow": a.variant === e(t).List
      }]),
      "data-test": "stash-module",
      "disable-gutters": a.disableGutters,
      "disable-padding": a.disablePadding || ["card", "list", "table"].includes(a.variant),
      "disable-elevation": a.disableElevation || a.variant === e(t).Table || a.variant === e(t).Card || a.variant === e(t).List
    }, {
      default: m(() => [
        c(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "disable-gutters", "disable-padding", "disable-elevation"]));
  }
});
export {
  v as MODULE_INJECTION,
  t as ModuleVariant,
  y as default
};
//# sourceMappingURL=Module.js.map
